
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 0H3C1.312 0 0 1.36 0 3v13.5c0 1.688 1.313 3 3 3h4.5v3.938c0 .375.234.562.563.562.093 0 .187 0 .328-.094L14.25 19.5H21c1.64 0 3-1.313 3-3V3c0-1.64-1.36-3-3-3zm1.5 16.5c0 .844-.703 1.5-1.5 1.5h-7.266l-.421.328L9 21.563V18H3a1.48 1.48 0 01-1.5-1.5V3c0-.797.656-1.5 1.5-1.5h18c.797 0 1.5.703 1.5 1.5v13.5zm-9.375-5.25h-6.75a.37.37 0 00-.375.375v.75c0 .234.14.375.375.375h6.75a.37.37 0 00.375-.375v-.75a.403.403 0 00-.375-.375zm4.5-4.5H6.375A.37.37 0 006 7.125v.75c0 .234.14.375.375.375h11.25A.37.37 0 0018 7.875v-.75a.403.403 0 00-.375-.375z","fill":"#586E8C"}})])
          )
        }
      }
    